// src/components/SVGs.js
import React from 'react';

export const Logo = () => (
  <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7l10 5 10-5-10-5zm0 6.5l10-5V17l-10 5-10-5V3.5l10 5z" fill="currentColor" />
  </svg>
);

export const HeroGraphic = () => (
  <svg width="400" height="400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7l10 5 10-5-10-5zm0 6.5l10-5V17l-10 5-10-5V3.5l10 5z" fill="currentColor" />
  </svg>
);

export const FeaturesGraphic = () => (
  <svg width="200" height="200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 7l10 5 10-5-10-5zm0 6.5l10-5V17l-10 5-10-5V3.5l10 5z" fill="currentColor" />
  </svg>
);
